// auth: woo
// 标准化时间处理函数

// 最小单位是毫秒1，时间换算都用毫秒作为基本值
const MILLISECOND: number = 1;
const SECOND: number = 1000 * MILLISECOND;
const MINUTE: number = 60 * SECOND;
const HOUR: number = 60 * MINUTE;
const DAY: number = 24 * HOUR;

// 当前时间
const now = function(): Date {
  return new Date();
};

// 时间加上一段期间得到新的时间
const add = (date: Date, duration: number) => {
  let t = new Date();
  t.setTime(date.getTime() + duration);
  return t;
};

// 从unix毫秒时间戳获得时间
const fromUnixMillSecond = function(timestamp: number): Date {
  let t = new Date();
  t.setTime(timestamp);
  return t;
};

// 从unix秒时间戳获得时间
const fromUnixSecond = function(timestamp: number): Date {
  let t = new Date();
  t.setTime(timestamp * 1000);
  return t;
};

// 时间的unix毫秒时间戳
const toUnixMillSecond = function(date: Date): number {
  return date.getTime();
};

// 时间的unix秒时间戳
const toUnixSecond = function(date: Date): number {
  return date.getTime() / 1000;
};

// 解析格式化字符串返回时间
const parseMinute = function(datestr: string, minutestr: string): Date {
  let ymd: string[] = datestr.split("-");
  let hm: string[] = minutestr.split(":");
  let d: Date = new Date();
  d.setFullYear(parseInt(ymd[0]));
  d.setMonth(parseInt(ymd[1]) - 1);
  d.setDate(parseInt(ymd[2]));
  d.setHours(parseInt(hm[0]));
  d.setMinutes(parseInt(hm[1]));
  return d;
};

// 时间格式化为string，日期部分
const formatDate = (date: Date): string => {
  var year = date.getFullYear();
  var month = prefixNumber2(date.getMonth() + 1);
  var day = prefixNumber2(date.getDate());
  return [year, month, day].join("-");
};

// 时间格式化为string，分钟部分
const formatMinute = (date: Date): string => {
  var hour = prefixNumber2(date.getHours());
  var minute = prefixNumber2(date.getMinutes());
  return [hour, minute].join(":");
};

// 时间格式化为string，秒
const formatTime = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return (
    [year, month, day].map(prefixNumber2).join("/") +
    " " +
    [hour, minute, second].map(prefixNumber2).join(":")
  );
};

// 补齐
const prefixNumber2 = (n: number): string => {
  const s = n.toString();
  return s[1] ? s : "0" + s;
};

// 求时间差，单位毫秒
const sub = (date1: Date, date2: Date): number => {
  const n = date1.getTime() - date2.getTime();
  return n < 0 ? -n : n;
};

// 计时器,单位毫秒
const watch = (): (() => number) => {
  const s = now();
  const f = (): number => {
    return sub(s, now());
  };
  return f;
};


const sleep_short_time = (timeout: number): Promise<null> => {
  return new Promise<null>(() => {
    setTimeout(() => {
    }, timeout);
  });

  /*return new Promise<null>(function(resolve) {
    setTimeout(resolve,timeout);
  });*/
};

// 休眠一段时间 ， 支持很长的时间
const sleep = async (timeout: number): Promise<void> => {
  // do {
  //   if (timeout > 10 * 1000) {
  //     await sleep_short_time(10 * 1000);
  //     timeout -= 10 * 1000;
  //   } else {
  //     await sleep_short_time(timeout);
  //     timeout = 0;
  //     // break;
  //   }
  // } while (timeout > 0);
  return new Promise(resolve => setTimeout(resolve, timeout));
  // return null;
};

const time = {
  MILLISECOND,
  SECOND,
  MINUTE,
  HOUR,
  DAY,
  now,
  add,
  sub,
  watch,
  fromUnixMillSecond,
  fromUnixSecond,
  toUnixMillSecond,
  toUnixSecond,
  formatDate,
  formatMinute,
  formatTime,
  parseMinute,
  sleep
};

export default time;
